import React, { useEffect } from "react";
import { useState } from "react";
import type { NextPage } from "next";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Layout from "../../layout/layout";
import Image from "next/image";
import subbanner from "../../assets/images/giftcard.png";
import bggift from "../../assets/images/gift-bg-r.png";
import front from "../../assets/images/gift-front.png";
import bggiftp from "../../assets/images/giftp.png";
import giftcol from "../../assets/images/card.png";
import logo from "../../assets/images/logo-pop-new1.png";
import styles from "../../styles/giftcard.module.scss";
import { useAppDispatch, wrapper } from "@/store";
import { authActions, selectAuth } from "@/store/slices/auth";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import httpClient from "@/api/http-client";
import { phoneRegExp } from "@/utils/regex";
import endpoints from "@/api/endpoints";
import { setTitle } from "@/store/slices/helmet";
// import { Swiper, SwiperSlide } from "swiper/react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Spinner } from "react-bootstrap";
// import "swiper/swiper.scss";
import SwiperGiftCard from "@/components/gift-card/swiper/swiper-slide";

const GiftCard: NextPage = () => {
  const [show, setShow] = useState(false);
  const [designList, setDesignList] = useState<any>([]);
  const [purposes, setPurposes] = useState<any>([]);

  const [templateList, setTemplateList] = useState<any>([]);
  const [preview, setPreview] = useState<any>(null);
  const [sameAs, setSameAs] = useState<any>(["new"]);
  const authState = useSelector(selectAuth);
  const [loading, setLoading] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const dispatch = useAppDispatch();
  const [thumbsSwiper, setThumbsSwiper] = useState<any>(null);
  const [openCard, setOpenCard] = useState(0);
  const [swiperValue, setSwiperValue] = useState<any>({
    value: "",
    index: -1,
    type: "",
  });

  const numberToArray = (n: number) => {
    return Array.from({ length: n }, (_, index) => index);
  };
  const formik = useFormik({
    initialValues: {
      items: [
        {
          purpose: "",
          // other_purpose: "",
          amount: "",
          design_image_url: "",
          template_image_url: "",
          name: "",
          email: "",
          mobile: "",
          message: "",
          show_sender_info: false,
          card_for_self: false,
        },
      ],
      card_no: "",
      image: "",
    },
    validationSchema: Yup.object().shape({
      items: Yup.array().of(
        Yup.object().shape({
          purpose: Yup.string().required("Please select your purpose"),
          // other_purpose: Yup.string().when("purpose", {
          //   is: (purpose: string) => purpose === "Other",
          //   then: Yup.string().required("Purpose is required"),
          //   otherwise: Yup.string(),
          // }),

          amount: Yup.number()
            .required("Please enter amount")
            .min(500, "Amount must be within 500-50000")
            .max(50000, "Amount must be within 500-50000")
            .test(
              "is-multiple-of-500",
              "Amount must be a multiple of 500",
              (value: any) => {
                return value % 500 === 0;
              }
            ),
          design_image_url: Yup.string().required("Please select a template"),
          template_image_url: Yup.string().required("Please select a GIF "),
          name: Yup.string().required("Name is required"),
          email: Yup.string()
            .required("Email is required")
            .email("Invalid email format"),
          mobile: Yup.string()
            .matches(phoneRegExp, "Mobile number is not valid")
            .test(
              "len",
              "Please enter your 9 digit mobile phone number without +971",
              (val: any) => {
                const length = val?.toString().length;
                return length === 9;
              }
            )
            .required("Mobile number is required"),
          // message: Yup.string().required("Meassage is required"),
        })
      ),
      card_no: Yup.string().when("items", {
        is: (items: any) =>
          items.reduce(
            (acc: number, item: any) => acc + Number(item.amount),
            0
          ) > 190000 && !authState?.user?.pan,
        then: Yup.string().required("Pan card number is required"),
        otherwise: Yup.string(),
      }),
      image: Yup.string().when("items", {
        is: (items: any) =>
          items.reduce(
            (acc: number, item: any) => acc + Number(item.amount),
            0
          ) > 190000 && !authState?.user?.pan,
        then: Yup.string().required("Image is required"),
        otherwise: Yup.string(),
      }),
    }),
    onSubmit: async (values) => {
      if (!authState.user) {
        dispatch(authActions.setIsModalOpen(true));
        return;
      }
      if (!authState.user.billing_address) {
        dispatch(authActions.setBillingModalOpen(true));
        return;
      }

      setLoading(true);

      let datas = values.items.map((obj, index) => {
        return {
          ...obj,
          design_image_url: purposes.find((v: any) => v.name == obj.purpose)
            .designs[obj.design_image_url],
          template_image_url: purposes.find((v: any) => v.name == obj.purpose)
            .templates[obj.template_image_url],
        };
      });
      // .map(({ other_purpose, ...rest }) => rest);
      try {
        if (
          values.items.reduce(
            (acc: number, item: any) => acc + Number(item.amount),
            0
          ) > 190000 &&
          values.card_no
        ) {
          const formData = new FormData();
          formData.append("card_no", values.card_no);
          formData.append("image", values.image);
          await httpClient.put(endpoints.auth.update_pancard(), formData);
        }

        const { data } = await httpClient.post(
          endpoints.giftCard.purchase(),
          datas
        );
        // toast(data.message, {
        //   type: "success",
        //   toastId: "gift-card-success",
        // });
        window.location.href = data.redirect;
      } catch (error: any) {
        if (error.response.data?.message) {
          toast(error.response.data.message, {
            type: "error",
            toastId: "gift-card-error",
          });
        } else {
          toast("Something went wrong! Try again!", {
            type: "error",
            toastId: "gift-card-error",
          });
        }
      }
      setLoading(false);
    },
  });
  const loadPurpose = async () => {
    try {
      const response = await httpClient.get(endpoints.giftCard.purpose());
      setPurposes(response.data?.data);
    } catch (error) {}
  };
  useEffect(() => {
    loadPurpose();
  }, []);
  useEffect(() => {
    if (swiperValue.index !== -1) {
      const value = formik.values.items;
      if (swiperValue.type == "gif") {
        value[swiperValue.index].template_image_url = swiperValue.value;
      } else {
        value[swiperValue.index].design_image_url = swiperValue.value;
      }

      formik.setFieldValue("items", [...value]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [swiperValue]);

  return (
    <Layout>
      <div className={styles.subbanner}>
        <Image src={subbanner} alt="Gift Card banner" />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className={styles.gift_card_main}>
          {formik.values.items.map((item, index) => (
            <>
              <div className="container">
                <div className={styles.gift_card_full}>
                  <div
                    onClick={() => {
                      openCard == index ? setOpenCard(-1) : setOpenCard(index);
                    }}
                    className={`${styles.gift_card_header} ${
                      openCard == index ? styles.active : ""
                    }`}
                  >
                    Gift Card {index + 1}
                  </div>{" "}
                  {openCard == index && (
                    <div className={styles.gift_card_body}>
                      {" "}
                      <div className="row">
                        <div className="col-md-6">
                          <div className={styles.gift_bg_ov}>
                            <Image
                              src={
                                purposes.find(
                                  (v: any) => v.name == item.purpose
                                )?.designs[item.design_image_url] || bggift
                              }
                              alt="bg gift"
                              height={546}
                              width={546}
                            />
                            <div className={styles.gift_bg_overlay}>
                              <Image
                                src={
                                  purposes.find(
                                    (v: any) => v.name == item.purpose
                                  )?.templates[item.template_image_url] || front
                                }
                                alt="bg gift"
                                height={280}
                                width={280}
                              />
                            </div>
                          </div>
                          <button
                            type="button"
                            className={styles.preview}
                            // disabled={!item.amount.length}
                            onClick={() => {
                              if (parseFloat(item.amount) > 0) {
                                setPreview(item);
                                handleShow();
                              } else {
                                toast("Please enter amount", {
                                  type: "error",
                                  toastId: "gift-card-error",
                                });
                              }
                            }}
                          >
                            Preview your Gift Card
                          </button>
                        </div>

                        <div className="col-md-6">
                          <div className={styles.gift_form_main}>
                            <div className={styles.header}>
                              Enter details for Gift Card purchase
                            </div>
                            <div className="col-md-12 mb-0 mt-3">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={"inlineCheckbox1" + index}
                                  checked={item.card_for_self}
                                  onChange={(e) => {
                                    if (!authState.user) {
                                      dispatch(
                                        authActions.setIsModalOpen(true)
                                      );
                                      return;
                                    }

                                    const value = formik.values.items;
                                    value[index].card_for_self =
                                      e.target.checked;
                                    if (e.target.checked) {
                                      value[index].name =
                                        authState.user?.name || "";
                                      value[index].email =
                                        authState.user?.email || "";
                                      value[index].mobile =
                                        authState.user?.mobile || "";
                                    } else {
                                      value[index].name = "";
                                      value[index].email = "";
                                      value[index].mobile = "";
                                    }

                                    formik.setFieldValue("items", [...value]);
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={"inlineCheckbox1" + index}
                                >
                                  Buy for Self
                                </label>
                              </div>
                              {index > 0 &&
                                numberToArray(index).map((x) => (
                                  <>
                                    <div className="col-md-12 mb-3 mt-3">
                                      <div className="form-check form-check-inline">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          checked={
                                            Number(sameAs[index]) === x
                                              ? true
                                              : false
                                          }
                                          id={"sameas" + index + x}
                                          onChange={(e) => {
                                            let value = formik.values.items;
                                            const same = sameAs;
                                            value[index].card_for_self =
                                              e.target.checked;

                                            if (e.target.checked) {
                                              same[index] = String(x);
                                              const template = templateList;
                                              template[index] = purposes.find(
                                                (v: any) =>
                                                  v.name ==
                                                  formik.values.items[x].purpose
                                              ).templates;
                                              setTemplateList([...template]);
                                              const design = designList;
                                              design[index] = purposes.find(
                                                (v: any) =>
                                                  v.name ==
                                                  formik.values.items[x].purpose
                                              ).designs;

                                              setDesignList([...design]);

                                              value[index] = {
                                                purpose:
                                                  formik.values.items[x]
                                                    .purpose,
                                                // other_purpose:
                                                //   formik.values.items[x]
                                                //     .other_purpose,
                                                amount:
                                                  formik.values.items[x].amount,
                                                design_image_url:
                                                  formik.values.items[x]
                                                    .design_image_url,
                                                template_image_url:
                                                  formik.values.items[x]
                                                    .template_image_url,
                                                name: formik.values.items[x]
                                                  .name,
                                                email:
                                                  formik.values.items[x].email,
                                                mobile:
                                                  formik.values.items[x].mobile,
                                                message:
                                                  formik.values.items[x]
                                                    .message,
                                                show_sender_info: false,
                                                card_for_self: false,
                                              };
                                            } else {
                                              same[index] = String(-1);

                                              value[index] = {
                                                purpose: "",
                                                // other_purpose: "",
                                                amount: "",
                                                design_image_url: "",
                                                template_image_url: "",
                                                name: "",
                                                email: "",
                                                mobile: "",
                                                message: "",
                                                show_sender_info: false,
                                                card_for_self: false,
                                              };
                                            }
                                            setSameAs([...same]);

                                            formik.setFieldValue("items", [
                                              ...value,
                                            ]);
                                          }}
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor={"sameas" + index + x}
                                        >
                                          Same as Gift Card {x + 1}
                                        </label>
                                      </div>{" "}
                                    </div>
                                  </>
                                ))}
                            </div>

                            <div className="row">
                              <>
                                {" "}
                                <div className="col-md-6">
                                  <div className={styles.form_group}>
                                    <label>
                                      Select purpose of buying Gift Card
                                    </label>
                                    <select
                                      value={item?.purpose}
                                      className={styles.custom_select}
                                      onChange={(e) => {
                                        const template = templateList;
                                        template[index] = purposes.find(
                                          (v: any) => v.name == e.target.value
                                        ).templates;
                                        setTemplateList([...template]);
                                        const design = designList;
                                        design[index] = purposes.find(
                                          (v: any) => v.name == e.target.value
                                        ).designs;

                                        setDesignList([...design]);

                                        const value = formik.values.items;
                                        value[index].purpose = String(
                                          e.target.value
                                        );
                                        value[index].template_image_url = "0";
                                        value[index].design_image_url = "0";

                                        formik.setFieldValue("items", [
                                          ...value,
                                        ]);
                                      }}
                                    >
                                      <option value="" disabled>
                                        {" "}
                                        Select
                                      </option>

                                      {purposes.length &&
                                        purposes.map((v: any) => (
                                          <>
                                            <option value={v.name}>
                                              {" "}
                                              {v.name}{" "}
                                            </option>
                                          </>
                                        ))}
                                    </select>
                                    {formik.touched.items &&
                                      formik.touched.items[index] &&
                                      formik.touched.items[index].purpose &&
                                      formik.errors.items &&
                                      formik.errors.items[index] &&
                                      // @ts-ignore
                                      formik.errors.items[index].purpose && (
                                        <small className="text-danger">
                                          {/* @ts-ignore */}
                                          {formik.errors.items[index].purpose}
                                        </small>
                                      )}
                                  </div>
                                </div>
                                {/* {formik.values.items[index].purpose == "Other" && (
                            <div className="col-md-3 mt-4">
                              <div className={styles.form_input}>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                  {...formik.getFieldProps(
                                    `items.${index}.other_purpose`
                                  )}
                                />{" "}
                                {formik.touched.items &&
                                  formik.touched.items[index] &&
                                  formik.touched.items[index].other_purpose &&
                                  formik.errors.items &&
                                  formik.errors.items[index] &&
                                  // @ts-ignore
                                  formik.errors.items[index].other_purpose && (
                                    <small className="text-danger">
                                      {formik.errors.items[index].other_purpose}
                                    </small>
                                  )}
                              </div>
                            </div>
                          )} */}
                                <div className="col-md-12">
                                  <div className={styles.form_group}>
                                    <label>
                                      Enter Amount (AED 500 - AED 50,000)
                                    </label>
                                    <div className={styles.filed_number}>
                                      <i className="bi bi-currency-rupee"></i>
                                      <input
                                        className={styles.number}
                                        type="number"
                                        placeholder=""
                                        {...formik.getFieldProps(
                                          `items.${index}.amount`
                                        )}
                                      />
                                    </div>
                                    <div className="w-100 clearfix">
                                      {formik.touched.items &&
                                        formik.touched.items[index] &&
                                        formik.touched.items[index].amount &&
                                        formik.errors.items &&
                                        formik.errors.items[index] &&
                                        // @ts-ignore
                                        formik.errors.items[index].amount && (
                                          <small className="text-danger">
                                            {/* @ts-ignore */}
                                            {formik.errors.items[index].amount}
                                          </small>
                                        )}
                                    </div>
                                    <ul className={styles.scroll_rupess}>
                                      {[1000, 2500, 5000, 10000, 20000].map(
                                        (v) => (
                                          <>
                                            <li
                                              className={
                                                Number(
                                                  formik.values.items[index]
                                                    ?.amount
                                                ) == v
                                                  ? styles.active
                                                  : ""
                                              }
                                            >
                                              <button
                                                type="button"
                                                onClick={() => {
                                                  const value =
                                                    formik.values.items;
                                                  value[index].amount =
                                                    String(v);
                                                  formik.setFieldValue(
                                                    "items",
                                                    [...value]
                                                  );
                                                }}
                                              >
                                                AED {v}
                                              </button>
                                            </li>
                                          </>
                                        )
                                      )}
                                    </ul>{" "}
                                  </div>
                                </div>
                                {!!item.purpose?.length && (
                                  <>
                                    <div className="col-md-12">
                                      <div className={styles.slider_main}>
                                        <div className={styles.heading}>
                                          Select Impression
                                        </div>
                                        <SwiperGiftCard
                                          type="gif"
                                          ind={index}
                                          list={templateList[index]}
                                          swiperValue={
                                            formik.values.items[index]
                                              .template_image_url
                                          }
                                          setswiperValue={setSwiperValue}
                                        />
                                        {formik.touched.items &&
                                          formik.touched.items[index] &&
                                          formik.touched.items[index]
                                            .template_image_url &&
                                          formik.errors.items &&
                                          formik.errors.items[index] &&
                                          (formik.errors.items[index] as any)
                                            .template_image_url && (
                                            <small className="text-danger">
                                              {
                                                (
                                                  formik.errors.items[
                                                    index
                                                  ] as any
                                                ).template_image_url
                                              }
                                            </small>
                                          )}
                                      </div>
                                    </div>
                                    <div className="col-md-12 mt-3">
                                      <div className={styles.slider_main}>
                                        <div className={styles.heading}>
                                          Select Template
                                        </div>
                                        <SwiperGiftCard
                                          type="template"
                                          ind={index}
                                          list={designList[index]}
                                          swiperValue={
                                            formik.values.items[index]
                                              .design_image_url
                                          }
                                          setswiperValue={setSwiperValue}
                                        />

                                        {/* <div className="slider-gift-main">
                                      <Swiper
                                        id={"swiper" + index}
                                        slidesPerView={5}
                                        watchSlidesProgress={true}
                                        navigation={{
                                          nextEl: ".arrow-left",
                                          prevEl: ".arrow-right",
                                        }}
                                        autoHeight={true}
                                        pagination={{
                                          clickable: true,
                                          dynamicBullets: true,
                                        }}
                                      >
                                        {!!designList[index]?.length &&
                                          designList[index]?.map(
                                            (v: any, k: any) => (
                                              <SwiperSlide key={k}>
                                                <div
                                                  onClick={() => {
                                                    const value =
                                                      formik.values.items;
                                                    value[
                                                      index
                                                    ].design_image_url = k;
                                                    formik.setFieldValue(
                                                      "items",
                                                      [...value]
                                                    );
                                                  }}
                                                  style={{ height: 100 }}
                                                  className={
                                                    formik.values.items[index]
                                                      .design_image_url === k
                                                      ? "swiper-gift active"
                                                      : "swiper-gift "
                                                  }
                                                >
                                                  <Image
                                                    src={v}
                                                    alt=""
                                                    layout="fill"
                                                    unoptimized
                                                  />
                                                </div>{" "}
                                              </SwiperSlide>
                                            )
                                          )}{" "}
                                      </Swiper>
                                      {designList[index]?.length > 5 && (
                                        <>
                                          {" "}
                                          <button
                                            type="button"
                                            className="arrow-right arrow arrow-next"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="#ff1932"
                                              viewBox="0 0 16 16"
                                            >
                                              <path d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0" />
                                            </svg>
                                          </button>
                                          <button
                                            type="button"
                                            className="arrow-left arrow arrow-prv"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="#ff1932"
                                              viewBox="0 0 16 16"
                                            >
                                              <path d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                                            </svg>
                                          </button>
                                        </>
                                      )}
                                    </div> */}
                                        {formik.touched.items &&
                                          formik.touched.items[index] &&
                                          formik.touched.items[index]
                                            .design_image_url &&
                                          formik.errors.items &&
                                          formik.errors.items[index] &&
                                          // @ts-ignore
                                          (formik.errors.items[index] as any)
                                            .design_image_url && (
                                            <small className="text-danger">
                                              {/* @ts-ignore */}
                                              {
                                                (
                                                  formik.errors.items[
                                                    index
                                                  ] as any
                                                ).design_image_url
                                              }
                                            </small>
                                          )}
                                      </div>
                                    </div>
                                  </>
                                )}
                                <div className="col-md-12">
                                  <div className={styles.form_main}>
                                    <div className={styles.heading_form}>
                                      Receiver Information
                                    </div>
                                    <div className={styles.form_input}>
                                      <label>
                                        Name<sup>*</sup>
                                      </label>
                                      <input
                                        type="text"
                                        placeholder=""
                                        {...formik.getFieldProps(
                                          `items.${index}.name`
                                        )}
                                      />
                                      {formik.touched.items &&
                                        formik.touched.items[index] &&
                                        formik.touched.items[index].name &&
                                        formik.errors.items &&
                                        formik.errors.items[index] &&
                                        // @ts-ignore
                                        formik.errors.items[index].name && (
                                          <small className="text-danger">
                                            {/* @ts-ignore */}
                                            {formik.errors.items[index].name}
                                          </small>
                                        )}
                                    </div>
                                    <div className={styles.form_input}>
                                      <label>
                                        Email<sup>*</sup>
                                      </label>
                                      <input
                                        type="email"
                                        placeholder=""
                                        {...formik.getFieldProps(
                                          `items.${index}.email`
                                        )}
                                      />
                                      {formik.touched.items &&
                                        formik.touched.items[index] &&
                                        formik.touched.items[index].email &&
                                        formik.errors.items &&
                                        formik.errors.items[index] &&
                                        // @ts-ignore
                                        formik.errors.items[index].email && (
                                          <small className="text-danger">
                                            {/* @ts-ignore */}
                                            {formik.errors.items[index].email}
                                          </small>
                                        )}
                                    </div>
                                    <div className={styles.form_input}>
                                      <label>
                                        Mobile Number.<sup>*</sup>
                                      </label>
                                      <input
                                        type="text"
                                        placeholder=""
                                        maxLength={9}
                                        {...formik.getFieldProps(
                                          `items.${index}.mobile`
                                        )}
                                      />
                                      {formik.touched.items &&
                                        formik.touched.items[index] &&
                                        formik.touched.items[index].mobile &&
                                        formik.errors.items &&
                                        formik.errors.items[index] &&
                                        // @ts-ignore
                                        formik.errors.items[index].mobile && (
                                          <small className="text-danger">
                                            {/* @ts-ignore */}
                                            {formik.errors.items[index].mobile}
                                          </small>
                                        )}
                                    </div>
                                    <div className={styles.form_input}>
                                      <label>Special Message </label>
                                      <textarea
                                        rows={3}
                                        maxLength={100}
                                        {...formik.getFieldProps(
                                          `items.${index}.message`
                                        )}
                                      ></textarea>
                                      <small className="float-md-end text-danger ">
                                        {item.message.length}/100
                                      </small>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-12 mt-2 mb-2">
                                  <div className="form-check form-check-inline">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      value=""
                                      id={"defaultCheck1" + index}
                                      checked={item.show_sender_info}
                                      onChange={(e) => {
                                        if (!authState.user) {
                                          dispatch(
                                            authActions.setIsModalOpen(true)
                                          );
                                          return;
                                        }
                                        const value = formik.values.items;
                                        value[index].show_sender_info =
                                          e.target.checked;
                                        formik.setFieldValue("items", [
                                          ...value,
                                        ]);
                                      }}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={"defaultCheck1" + index}
                                    >
                                      Add Sender Info
                                    </label>
                                  </div>
                                </div>
                              </>
                              {formik.values.items.length - 1 !== 0 && (
                                <div className="col-md-6">
                                  <button
                                    type="button"
                                    disabled={loading}
                                    className={styles.button}
                                    onClick={() => {
                                      let data = formik.values.items.filter(
                                        (v: any, x: any) => x !== index
                                      );
                                      if (data.length == 1) {
                                        setOpenCard(0);
                                      }
                                      formik.setFieldValue("items", [...data]);
                                    }}
                                  >
                                    Remove Gift Card {index + 1}
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>{" "}
                    </div>
                  )}
                </div>
              </div>
            </>
          ))}
          <>
            <div className="row justify-content-center">
              <div className="col-md-6">
                <div className="row mt-0">
                  <div className="col-md-6">
                    <div className={styles.payamount}>
                      <span className={styles.span}>Total Payble Amount </span>{" "}
                      - AED{" "}
                      {formik.values.items.reduce(
                        (accumulator: any, currentValue: any) =>
                          Number(accumulator) + Number(currentValue.amount),
                        0
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className={styles.payamount}>
                      <span className={styles.span}>Total Gift Card</span> -{" "}
                      {formik.values.items?.length || 0}
                    </div>
                  </div>
                </div>
                {formik.values.items.reduce(
                  (acc: number, item: any) => acc + Number(item.amount),
                  0
                ) > 190000 &&
                  !authState?.user?.pan && (
                    <div className="row mt-0">
                      <div className="col-md-6">
                        <label className="required">
                          Pan Card <sup>*</sup>
                        </label>
                        <p className="my-0">
                          <small style={{ fontSize: 14 }}>
                            PAN card is required for transaction above 1.9 lac
                          </small>
                        </p>
                        <input
                          className="form-control"
                          type="text"
                          {...formik.getFieldProps("card_no")}
                        />
                        {formik.touched.card_no && formik.errors.card_no ? (
                          <small className="text-danger">
                            {formik.errors.card_no}
                          </small>
                        ) : null}
                      </div>
                      <div className="col-md-6">
                        <label className="required">
                          Pan Card Image <sup>*</sup>
                        </label>

                        <input
                          type="file"
                          className="form-control"
                          style={{ marginTop: "20px", padding: "5px" }}
                          accept="image/*"
                          onChange={(event) => {
                            const file =
                              event.currentTarget.files &&
                              event.currentTarget.files[0];
                            if (file) {
                              formik.setFieldValue("image", file);
                            }
                          }}
                        />
                        {formik.touched.image && formik.errors.image ? (
                          <small className="text-danger">
                            {formik.errors.image}
                          </small>
                        ) : null}
                      </div>
                    </div>
                  )}
                <div className="row mt-4">
                  {formik.values.items.length < 5 && (
                    <div className="col-md-6">
                      <button
                        type="button"
                        className={styles.button}
                        onClick={() => {
                          setOpenCard(formik.values.items.length);

                          setSameAs([...sameAs, "new"]);
                          formik.setFieldValue("items", [
                            ...formik.values.items,
                            {
                              purpose: "",
                              // other_purpose: "",
                              amount: "",
                              design_image_url: "",
                              template_image_url: "",
                              name: "",
                              email: "",
                              mobile: "",
                              message: "",
                              show_sender_info: false,
                              card_for_self: false,
                            },
                          ]);
                        }}
                      >
                        Add Anothor Gift Card
                      </button>
                    </div>
                  )}
                  <div className="col-md-6">
                    <button
                      type="submit"
                      disabled={loading}
                      className={styles.button}
                    >
                      {loading && <Spinner animation="border" size="sm" />}{" "}
                      Checkout
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        </div>
      </form>
      <Modal
        show={show}
        onHide={handleClose}
        className={styles.custom_modal_gift}
      >
        <Modal.Header className={styles.header_pop} closeButton>
          {/* <Modal.Title>Modal heading</Modal.Title> */}
        </Modal.Header>
        <Modal.Body className="p-2">
          {preview && (
            <>
              <div className={styles.gift_pop_container}>
                {!String(preview?.design_image_url).length ||
                !String(preview?.template_image_url).length ? (
                  <div className={styles.text_image}>
                    Please select Impression & Template
                  </div>
                ) : (
                  <div className={styles.gift_card_image}>
                    <Image
                      src={
                        purposes.find((v: any) => v.name == preview?.purpose)
                          ?.designs[preview?.design_image_url]
                      }
                      alt="bg gift"
                      height={368}
                      width={368}
                    />
                    <div className={styles.gift_bg_overlay}>
                      <Image
                        src={
                          purposes.find((v: any) => v.name == preview?.purpose)
                            ?.templates[preview?.template_image_url]
                        }
                        alt="bg gift"
                        height={230}
                        width={230}
                      />
                    </div>
                  </div>
                )}
                <div className={styles.gift_bg}>
                  {/* {!!preview?.purpose.length && (
                    <div className="user-name">
                      {
                        purposes.find((v: any) => v.name == preview?.purpose)
                          .sentiment
                      }{" "}
                      {preview?.purpose}
                      <span> {preview?.name}</span>
                    </div>
                  )} */}
                  <div className={styles.user_name}>
                    <span> {preview?.name}</span>
                  </div>

                  {!!preview?.message.length && (
                    <div className={styles.user_msg}>{preview?.message} </div>
                  )}
                  {!!preview.show_sender_info && (
                    <div className={styles.form_name}>
                      From : {authState.user?.name}
                    </div>
                  )}
                  <div className={styles.line}></div>
                  <div className={styles.user_amount}>
                    Rs. <span>{preview?.amount}</span>
                  </div>
                  <div className={styles.form_name_user}>
                    <Image src={logo} alt="logo" />
                  </div>
                  <div className="clearfix"></div>
                </div>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
    </Layout>
  );
};
export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async () => {
    store.dispatch(setTitle("Buy Gift Card"));
    return {
      props: {},
    };
  }
);

export default GiftCard;
